import ApiService from "../../../services/api";
import moment from "moment";
import $ from "jquery";
import helpers from "../../../shared/fleetbox-helpers";
import property from '../chartProperties';

export default {
	data: function() {
		return {
			/* CO2 Emitted */
			pdfOptions: {
				landscape: true,
				fileName: "CO2 Emessa",
				title: "CO<sub>2</sub> Emessa"
			},
			co2EmittedModal: false,
			legend: {
				position: "bottom",
				item: {
					visual: function(e) {
						var color = property.co2Emitted.colorDot; //e.options.markers.background;
						var labelColor = e.options.labels.color;
						var rect = new kendo.geometry.Rect([0, 0], [200, 200]);
						var layout = new kendo.drawing.Layout(rect, {
							spacing: 5,
							alignItems: "center"
						});

						var marker = new kendo.drawing.Path({
							fill: {
								color: color
							},
							stroke: {
								color: color
							}
						})
							.moveTo(0, 0)
							.lineTo(0, 10)
							.lineTo(30, 10)
							.lineTo(30, 0)
							.close();

						var labelPre = new kendo.drawing.Text("CO", [0, 0], {
							fill: {
								color: labelColor
							},
							font: "13px 'Montserrat Light', montserrat-light !important"
						});

						var labelSub = new kendo.drawing.Text("2", [0, 0], {
							fill: {
								color: labelColor
							},
							font: "8px 'Montserrat Light', montserrat-light !important"
						});

						var labelSuf = new kendo.drawing.Text(" Emessa", [0, 0], {
							fill: {
								color: labelColor
							},
							font: "13px 'Montserrat Light', montserrat-light !important"
						});

						layout.append(marker, labelPre, labelSub, labelSuf);
						layout.reflow();

						return layout;
					}
				}
			},
			co2Emitted: [
				{
					name: "CO2 Emessa",
					field: "value",
					labels: {
						visible: true,
						background: "none",
						format: "n2",
						font: "10px montserrat-light"
					},
					markers: {
						background: property.co2Emitted.colorDot
					},
					color: property.co2Emitted.colorLine
				}
			],
			co2EmittedData: [],
			co2EmittedTooltip: {
				visible: true,
				template: "<span>CO<sub>2</sub> Emessa dal #= dataItem.from # al #= dataItem.to #: #= kendo.toString(value, 'n2') # KG</span>"
			},
			co2EmittedCategoryAxis: {
				categories: [],
				majorGridLines: {
					visible: false
				},
				labels: {
					font: "10px montserrat-light"
				}
			},
			co2EmittedValueAxis: [
				{
					//max: 50,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					labels: {
						rotation: "auto",
						visible: false,
						font: "10px montserrat-light"
					}
				}
			],
			co2EmittedModalValueAxis: [
				{
					//max: 50,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					title: {
						rotation: 0,
						text: "KG",
						font: "10px montserrat-light"
					},
					labels: {
						format: "n0",
						font: "10px montserrat-light"
					}
				}
			],

			co2EmittedIndex: 0,
			modalTitle: "CO<sub>2</sub> emessa da",
			exportTitle: "CO<sub>2</sub> emessa da",
			loading: true
			/* CO2 Emitted */
		};
	},
	watch: {},
	created() {
		this.getTripsCounter();
	},
	methods: {
		getTooltipHtml(e) {
			var str = kendo.template("<span></span>CO<sub>2</sub> Emessa dal #= dataItem.from # al #= dataItem.to #: #= value # KG</span>");

			return str;
		},
		co2EmittedClickHandler() {
			this.co2EmittedModal = true;
			$(".k-tooltip.k-chart-tooltip").remove();
			setTimeout(() => {
				this.co2EmittedIndex++;
			}, 200);
		},
		/* Trips Counter */
		getTripsCounter() {
			var self = this;
			ApiService.getTripsCounter().then(res => {
				self.getUserFriendlyTripsCounter(res);
			});
		},

		getUserFriendlyTripsCounter(data) {
			var self = this;
			if (data && data.length > 0) {
				var maxco2EmittedValue = _.maxBy(data, function(o) {
					return Math.abs(o.values.co2_emitted);
				}).values.co2_emitted;

				var maxDate = _.maxBy(data, function(o) {
					return moment(o.to);
				}).to;

				var minDate = _.minBy(data, function(o) {
					return moment(o.from);
				}).from;

				this.modalTitle = `CO<sub>2</sub> emessa dal ${this.$options.filters.dateToString(moment(minDate))} al ${this.$options.filters.dateToString(moment(maxDate))} (settimanale)`;
				this.exportTitle = `CO2 emessa dal ${this.$options.filters.dateToString(moment(minDate))} al ${this.$options.filters.dateToString(moment(maxDate))} (settimanale)`;
				this.pdfOptions.title = `CO2 emessa dal ${this.$options.filters.dateToString(moment(minDate))} al ${this.$options.filters.dateToString(moment(maxDate))}`;
				this.pdfOptions.fileName = helpers.chartPdffileName(this, "CO2_Emessa", minDate, maxDate);
				data.forEach(function(item) {
					self.co2EmittedCategoryAxis.categories.push(self.$options.filters.dateToString(item.from));

					var pco2Emitted = (Math.abs(item.values.co2_emitted) * 100) / Math.abs(maxco2EmittedValue);
					var percentageco2Emitted = pco2Emitted / 100;
					var colorco2EmittedValue = property.co2Emitted.colorDot;//self.pickHex([80, 145, 0], [116, 212, 0], percentageco2Emitted);

					self.co2EmittedData.push({
						from: self.$options.filters.dateToString(item.from),
						to: self.$options.filters.dateToString(item.to),
						value: item.values.co2_emitted ? item.values.co2_emitted : 0,
						color: colorco2EmittedValue
					});
				});
			}

			setTimeout(function() {
				self.loading = false;
			}, 200);
		},
		/* Trips Counter */

		//#region Utils
		pickHex(color1, color2, weight) {
			var w1 = weight;
			var w2 = 1 - w1;
			var rgb = [Math.round(color1[0] * w1 + color2[0] * w2), Math.round(color1[1] * w1 + color2[1] * w2), Math.round(color1[2] * w1 + color2[2] * w2)];
			return rgb;
		},

		exportAsPdf() {
			// var chart = this.$refs.chartCo2EmittedModal.kendoWidget();
			// chart.saveAsPDF();
			var fileName = this.pdfOptions.fileName;
			var container = $(`<div><div id="chart-container" style="text-align: center; width: 1100px">
			<span style="height: 50px; width: 500px; font: bold 20px montserrat-bold; margin-top: 10px; margin-bottom: 10px; color: #777;" id="chart-title"></span>
			<div id="chart"></div>
			</div>`)
				.css({
					position: "absolute",
					top: 0,
					left: -1500,
					height: 600
				})
				.appendTo("body");

			function cleanup() {
				container
					.find("#chart")
					.getKendoChart()
					.destroy();
				container.remove();
			}

			this.createChart(container);

			setTimeout(() => {
				kendo.drawing
					.drawDOM($(container).find(`#chart-container`), {
						margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" }
					})
					.then(function(group) {
						return kendo.drawing.exportPDF(group);
					})
					.done(function(data) {
						kendo.saveAs({
							dataURI: data,
							fileName: fileName
						});
						setTimeout(() => {
							cleanup();
						}, 500);
					});
			}, 800);

			// this.createChart(container.find("#chart-container"), {
			// 	// Custom settings for export
			// 	transitions: false,

			// 	// Cleanup
			// 	render: function(e) {
			// 		e.sender.saveAsPDF();
			// 		setTimeout(cleanup, 500);
			// 	}
			// });
		},

		createChart(container) {
			var self = this;

			var options = {
				pdf: self.pdfOptions,
				theme: "metro",
				title: {
					text: ""
					// text: self.exportTitle.toUpperCase(),
					// font: "bold 20px montserrat-bold",
					// align: "center"
				},
				legend: {
					visible: true,
					position: "bottom",
					item: {
						visual: function(e) {
							var color = property.co2Emitted.colorDot; //e.options.markers.background;
							var labelColor = e.options.labels.color;
							var rect = new kendo.geometry.Rect([0, 0], [200, 50]);
							var layout = new kendo.drawing.Layout(rect, {
								spacing: 0,
								alignItems: "end",
								alignContent: "center"
							});

							var marker = new kendo.drawing.Path({
								fill: {
									color: color
								},
								stroke: {
									color: color
								}
							})
								.moveTo(0, 0)
								.lineTo(0, 10)
								.lineTo(30, 10)
								.lineTo(30, 0)
								.close();

							var labelPre = new kendo.drawing.Text(" CO", [0, 0], {
								fill: {
									color: labelColor
								},
								font: "13px 'Montserrat Light', montserrat-light"
							});

							var labelSub = new kendo.drawing.Text("2", [0, 0], {
								fill: {
									color: labelColor
								},
								font: "8px 'Montserrat Light', montserrat-light"
							});

							var labelSuf = new kendo.drawing.Text(" EMESSA", [0, 0], {
								fill: {
									color: labelColor
								},
								font: "13px 'Montserrat Light', montserrat-light"
							});

							layout.append(marker, labelPre, labelSub, labelSuf);
							layout.reflow();

							return layout;
						}
					}
				},
				seriesDefaults: {
					type: "line",
					labels: {
						visible: true
					}
				},
				dataSource: {
					data: self.co2EmittedData
				},
				series: [
					{
						field: "value",
						name: "CO<sub>2</sub> Emessa",
						labels: {
							visible: true,
							font: "13px montserrat-light",
							format: "n2"
						},
						markers: {
							background: property.co2Emitted.colorDot
						},
						color: property.co2Emitted.colorLine
					}
				],
				valueAxis: {
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					title: {
						text: "KG",
						rotation: 0,
						font: "13px montserrat-light"
					},
					labels: {
						font: "13px montserrat-light",
						format: "n0"
					}
				},
				categoryAxis: {
					categories: self.co2EmittedCategoryAxis.categories,
					majorGridLines: {
						visible: false
					},
					line: {
						visible: false
					},
					labels: {
						font: "13px montserrat-light"
					}
				}
			};

			var titleChart = self.exportTitle.replace("CO2", "co<sub>2</sub>").toUpperCase();
			$(container)
				.find(`#chart-title`)
				.html(titleChart);

			//options = $.extend(true, options, exportOptions);
			container.find(`#chart`).kendoChart(options);
		},
		exportAsXlsx(type) {
			var self = this;
			ApiService.exportAnalyticsXlsx("co2", type).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `CO2 Emessa.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		}
		//#endregion
	}
};
